const constants = {
    // JAVÍTÁS: dbmanager.js sync() - ha egy kiküldött, de vissza nem igazolt
    // (storedone) store ennyi ideig "repülőben" marad, a sync() újra
    // megpróbálja kiküldeni. Biztonsági háló egy ritka, néma ack-vesztés
    // ellen; a normál eset (storedone pár száz ms-en belül megjön) ezt
    // sosem éri el.
    SYNC_PENDING_STALE_MS: 15000,
    // JAVÍTÁS: dbmanager.js _startStaleRetry() - ilyen gyakran nézzük meg, van-e
    // a fenti időnél régebben vissza nem igazolt küldés. Csak memóriabeli
    // ellenőrzés, a sync() csak akkor indul, ha tényleg van ilyen.
    SYNC_STALE_RETRY_CHECK_MS: 5000,
    // Külső események (user nyomogatása által okozott)
    ACTIONS: {
        STRAND: {
            GOALKEEPER: 'setGoalKeeperAfterStart',
        },
        BALLPLACED: 'ballPlaced',
        CLOSE: {
            OFFICIALSLIST: 'closeOfficialsList',
            MODAL: 'closeModal',
        },
        DISABLE: {
            CARDS: 'disableCards',
            COURT: 'disableCourt',
            GATE: 'disableGate',
            LOSTBALLS: 'disableLostballs',
            PENALTIES: 'disableExclusions',
            PENALTYSHOTS: 'disablePenaltyShots',
            SHOTS: 'disableShots',
            STAFF: {
                A: 'disablestaffA',
                B: 'disablestaffB',
            },
            TEAM: {
                A: 'disableteamA',
                B: 'disableteamB',
            },
            TIMEOUTS: 'disableTimeouts',
        },
        EXCLUDEOFFICIAL: 'excludeOfficial',
        EXCLUDEPLAYER: 'excludePlayer',
        EXCLUDEPLAYERDIALOG: 'excludePlayerDialog',
        CARDS: {
            GIVE: {
                BLUE: 'give_blue_card',
                RED: 'give_red_card',
                YELLOW: 'give_yellow_card',
                STRAND_YELLOW: 'give_strand_yellow',
            },
            TAKE: {
                BLUE: 'take_blue_card',
                RED: 'take_red_card',
                YELLOW: 'take_yellow_card',
                STRAND_YELLOW: 'take_strand_yellow',
            },
        },
        HIDEPICKER: 'hidePicker',
        OPENGATE: 'openGate',
        PENALTIES: {
            GIVE: 'penalty',
            TAKE: 'absolve',
        },
        PLAYERENTRY: 'player_entry',
        RESTORE: {
            // Szerkesztéskor az eredeti rekordban kijelölt dolgokat kapcsolja be
            SELECTION: 'restoreSelection',
        },
        SELECTED: {
            ACTION: 'selectedAction',
            ACTIONTYPE: 'selectedActionType',
            AREA: 'selectedArea',
            GATE: 'selectedGateArea',
            PLAYER: 'selectedPlayer',
            TEAM: 'selectedTeam',
        },
        TOGGLE: {
            DIRECTION: 'toggleDirection',
            PAUSE: 'togglePause',
            PLAYER: {
                PLAY: 'togglePlayerPlay',
                SELECT: 'togglePlayerSelect',
            },
            TIMELINE: 'toggleTimeline',
        },
        SINGLE_SCORE_ACTIONS: [
            'gol',
            'gol7m'
        ],
        DOUBLE_SCORE_ACTIONS: [
            'gol2p',
            'gol6m'
        ],
        // Ezeknél az akcióknál (vagy ha egy ilyen eseményt szerkesztettek) a
        // CR mentés után a teljes állás/lap/kiállítás újraszámolás lefut
        // (App.vue RECALCULATE kezelő -> game/reCalculateScores). Közös lista,
        // hogy az ActionBar.vue afterSave-je tudja, mikor felesleges külön
        // listarendezést indítania (l. 77. tétel).
        RECALCULATE_ACTIONS: ['gol', 'gol7m', 'gol2p', 'gol6m', '2perc', '4perc', 'sargalap', 'piroslap', 'keklap', 'kiallitas'],
        ACTION_MAPPING: {
            normalShot: 'Normál lövés',
            porgoShot: 'Pörgő lövés',
            specialistaShot: 'Specialista lövés',
            kinaiShot: 'Kínai lövés',
            direktShot: 'Direkt lövés',
        },
        BASIC: {
            STRAND_ACTIONSHOTS: [
                'gol',
                'gol2p',
                'rontott',
                'kapufa',
                'vedett'
            ],
            STRAND_PENALTYSHOTS: [
                '6m',
                'rontott6m',
                'kapufa6m',
                'gol6m',
                'vedett6m',
                'full'
            ],
            STRAND_MISTAKES: [
                'eladott',
                'technikai'
            ]
        }
    },
    // Ezeknél az akcióknál fordul meg a támadás iránya
    CHANGEDIRECTION: [
        'eladott',
        'gol',
        'gol7m',
        'gol6m',
        'gol2p',
        'rontott',
        'rontott7m',
        'rontott6m',
        'technikai'
    ],
    // Belső események (NEM feltétlen user nyomogatása által okozott)
    EVENTS: {
        ALERTBOX: 'openAlert',
        BASICMODECHANGED: 'basicmodechanged',
        CHANGE: {
            CONNECTION: 'changeConnection',
            CONNECTIONSAVEMETHOD: 'changeConnectionSaveMethod',
            DARKMODE: 'darkModeChange',
            HOTKEYS: 'hotkeysChange',
            DIRECTION: 'changeDirection',
            GAMEDATA: 'changeGamedata',
            GOALKEEPERS: 'changeGoalkeepers',
            GAMEDATALOADED: 'gameDataIsLoaded',
            SCREENMODE: 'screenMode',
            DIALOG: 'toggleDialog',
        },
        // Service worker: új alkalmazás-verzió érhető el. A PWA service workere
        // alapértelmezés szerint "waiting" állapotban áll, amíg az alkalmazás
        // ÖSSZES füle be nem zárul - egy sima oldalfrissítés NEM aktiválja.
        // Emiatt a kliensoldali javítások hetekig nem jutottak el a
        // felhasználókhoz. Erre az eseményre az App.vue egy felugró sávot
        // jelenít meg "Frissítés" gombbal (l. ott a részletes magyarázatot).
        SW: {
            UPDATED: 'swUpdated',
        },
        CLOCK: {
            CHANGED: 'clockChanged',
            // Mikor a ReportScreen befejezte az inicializálás, akkor az órának ellenőriznie kell, hogy hol áll,
            // illetve blokkolnia kell-e más komponenseket
            CHECK: 'clockCheck',
            DISABLE: 'clockDisable',
            SETTINGSDISABLE: 'clockSettingsDisable',
            PAUSED: 'clockPaused',
            SET: 'setTime',
            STARTED: 'clockStarted',
            STOP: 'stopClock',
            TICK: 'tickSecond',
            MINUTECHANGED: 'minuteChanged',
            LOAD: 'tickLoad',
            CLOSE: 'clockClose',
        },
        COMPONENTS: {
            ACTION: {
                CARDS: {
                    CREATED: 'action_cards_created',
                },
            },
        },
        RECALCULATE: 'reCalculateScores',
        ACCEPT_TIMEOUT: 'acceptTimeOut',
        ACCEPTABLE_TIMEOUT_UUID: 'acceptableTimeOutUUID',
        REFRESH_TIMEOUT: 'refreshTimeOut',
        GETINIT: 'getInit',
        LASTTIMELOAD: 'lastTimeLoad',
        LOGIN: {
            ACTION: 'login',
            CHANGE: 'loginchange',
            ERROR: 'login_error',
            SUCCESS: 'login_success',
        },
        MATCH: {
            RESTOREDONE: 'matchrestoredone',
            START: 'startMatch',
        },
        MODIFYITEMDATA: 'modifyItemData',
        MIRROR: 'screenMirrorChanged',
        PERIOD: {
            CHANGED: {
                CLOCK: 'periodChangedClock',
                SUBSTITUTE: 'periodChangedSubstitute',
                SELECTEDPERIOD: 'changedSelectedPeriod'
            },
            // DMR miatt van szerepe, ha jön event a sockettől, amiben van period change, akkor az App.vue-ban van ennek a listenere, ami meghívja a megfelelő methodot azon belül
            // sajnos a this.$emit nem volt elég
            CHANGE: 'changePeriod',
            ENDS: 'periodEnds',
            SET: {
                ITEMS: 'setperiodItems',
                STATE: 'setPeriodState',
            },
            ENABLE: {
                SHOOTOUT: 'shootOut'
            }
        },
        DB_CHANGE: 'DB_CHANGE_EVENT',
        RECORD: {
            CREATE: 'recordCreateStart',
            CREATED: 'recordCreated',
            // Ha a egy másik komponens akar a TimelineList-tel kitöröltetni valamit
            // Akkor ezt az eventet kell eldobni, a UUID paraméterrel
            DELETE: 'deleteRecord',
            DELETED: 'recordDeleted',
            // Ha a rekord a kód egy másik részén lett létrehozva és adatbázisba írva
            // Ezekkel a rekordokkat egyedül annyi teendő van, hogy a timeline-ba be kell raknunk
            DMRSYNC: 'dmrToReport',
            PUSH: 'recordPush',
        },
        SET: {
            GAMEDATA: 'setGameData',
        },
        SHOWGOALKEEPERMENU: 'showGoalKeeperMenu',
        STORE: {
            BEGIN: 'store',
            DONE: 'storedone',
        },
        TEAMUPDATE: 'teamUpdate',
        TIMELINE: {
            ITEM: {
                CLOSE: 'closeTimelineItem',
                DELETE: {
                    ALL: 'deleteTimelineItems',
                    ONE: 'deleteTimelineItem',
                },
                EDIT: {
                    ONE: 'editTimelineItem',
                    ALL: 'editTimelineItems',
                    UP: 'editExcludeUpTimelineItem',
                },
                SAVE: {
                    ONE: 'saveTimelineItem',
                    ALL: 'saveTimelineItems',
                }
            },
        },
        USERDATA: 'userdata',
        SUBSTITUTE: {
            COUNTPLAYTIME: 'countPlaytime'
        }
    },
    // Oldal újratöltéskor ezeket az eseményeket kell újra visszarakni a timeline-ba
    TIMELINEACTIONS: {
        // A report oldalon
        REPORT: [
            'vazlat',
            'eladott',
            'gol',
            'gol2p',
            'gol7m',
            'gol6m',
            'kapufa',
            'blokkolt',
            'kapufa7m',
            'keklap',
            'piroslap',
            'sargalap',
            'kiallitas',
            'rontott',
            'rontott7m',
            'technikai',
            'vedett',
            'vedett7m',
            'timeOut',
            '2perc',
            '4perc',
            'vedett6m',
            'kapufa6m',
            'rontott6m',
            'dmr-keklap',
            'dmr-piroslap',
            'dmr-sargalap',
            'dmr-2perc',
            'dmr-4perc',
            'dmr-timeOut'
        ],
        // A subtitute oldalon
        SUBSTITUTE: [
            'Csere',
            'Kezdőjátékos',
            'Felmegy',
            'Kiállítás',
            'Hivatalos Kiállítás',
        ]
    },
    DMR: {
        MESSAGE: 'sendMessage',
        SELECT: 'selectEvent',
        SELECT_ALL: 'selectAllEvent',
        APPROVE_ALL: 'acceptAllEvent',
        APPROVE: 'acceptEvent',
        REJECT: 'rejectEvent',
        REJECT_MODAL: 'rejectModalShow',
        APPROVE_MODAL: 'approveModalShow',
        MISSING_MODAL: 'missingActionShow',
        SEND_MISSING: 'rendMissingAction',
        SELECT_REJECT_REASON: 'selectRejectReason',
        REJECT_REASONS: {
            'player': 'Játékos hibásan lett rögzítve',
            'event': 'Esemény hibásan lett rögzítve',
            'time': 'Időpont hibásan lett rögzítve',
            'missclick': 'Nem történt ilyen esemény'
        },
        REJECT_REASONS_SHORT: {
            'player': 'Játékos hibás rögzítése',
            'event': 'Esemény hibás rögzítése',
            'time': 'Időpont hibás rögzítése',
            'missclick': 'Nem történt ilyen esemény'
        },
        ACTION_LABELS: {
            'gol':'Gól',
            'gol7m':'7m Gól',
            'rontott7m':'7m Rontott',
            'kapufa7m':'7m Kapufa',
            'vedett7m':'7m Védett',
            'keklap':'Kék lap',
            'piroslap':'Piros lap',
            'sargalap':'Sárga lap',
            '2perc':'2 perc',
            '4perc':'2+2 perc',
            'timeOut':'Időkérés',
            'dmr-keklap': 'Kék lap',
            'dmr-piroslap': 'Piros lap',
            'dmr-sargalap': 'Sárga lap',
            'dmr-2perc': '2 perc',
            'dmr-4perc': '2+2 perc',
            'dmr-timeOut': 'Időkérés'
        },
        DMR_DRAFTS: [
            'dmr-keklap',
            'dmr-piroslap',
            'dmr-sargalap',
            'dmr-2perc',
            'dmr-4perc',
            'dmr-timeOut'
        ],
        DRAFTS_TO_EVENT: {
            'dmr-keklap': 'keklap',
            'dmr-piroslap': 'piroslap',
            'dmr-sargalap': 'sargalap',
            'dmr-2perc': '2perc',
            'dmr-4perc': '4perc',
            'dmr-timeOut': 'timeOut'
        },
        APPROVE_REQUIRED: [
            'gol',
            'gol7m',
            'kapufa7m',
            'vedett7m',
            'rontott7m',
            'keklap',
            'piroslap',
            'sargalap',
            '2perc',
            '4perc',
            'timeOut'
        ]
    },
    SOCKET: {
        ACTIONS: {
            CONNECT: 'connect',
            DISCONNECT : 'disconnect',
            GETINIT: 'getInit',
            INIT: 'init',
            LOGIN: 'login',
            LOGOUT: 'logout',
            MATCHDATA : 'matchdata',
            MONGOERROR: 'mongoerror',
            RESTORE: 'matchrestore',
            RESTOREDONE: 'matchrestoredone',
            LOGINCHANGE: 'loginchange',
            LOGINERROR: 'login_error',
            LOGINSUCCESS: 'login_success',
            USERDATA: 'userdata',
            STOREDONE: 'storedone',
            STORE: 'store',
            SYNC: 'sync',
            NOPERMISSION: 'nopermission',
            NOTSTARTED: 'game-not-started',
            // Új esemény küldése a DmrScreen számára a ReportScreenről
            DMRPUSH: 'dmrpush',
        }
    }
};

module.exports = constants;
